import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
  ReduxDispatchProps,
  ReduxSelectorProps,
} from '../../services/constants';
import './../text-editor/style.scss';
import ToggleButton from '../../../components/common/toggleSwitchCustom';
import ArrowDown from '../../../assets/svg/ArrowDown';
import { Controller, useFormContext } from 'react-hook-form';

export type TermsAndConditionProps = {
  headerContent: string;
  acknowledgeContent: string;
  toggleOption: string;
  checkBoxVerticalAlign: string;
  defaultChecked: boolean;
  color: string;
  showAcknowledgeDropdown: boolean;
  showHeader: boolean;
  checkBoxData: {
    isRequired: boolean;
    errorMessage: string;
  };
};

export const CheckBoxComponent = ({
  showAcknowledgeDropdown,
  showHeader,
  headerContent,
  acknowledgeContent,
  checkBoxVerticalAlign,
  toggleOption,
  defaultChecked,
  color,
  checkBoxData: { isRequired: requiredForPayment, errorMessage: errorMsg },
}: TermsAndConditionProps & ReduxDispatchProps & ReduxSelectorProps) => {
  const { control, formState } = useFormContext();
  const [uniqueName] = useState(() => `checkbox-${uuidv4()}`);

  const [isopen, setIsOpen] = useState(false);
  return (
    <React.Fragment>
      <div className={`py-2 text-editor-content`}>
        <fieldset>
          <legend className="sr-only">Notifications</legend>
          <div className="space-y-2">
            <div className="flex">
              <div className={`flex h-auto ${checkBoxVerticalAlign} flex-col`}>
                {toggleOption === 'checkbox' ? (
                  <Controller
                    control={control}
                    name={uniqueName}
                    defaultValue={defaultChecked}
                    rules={{
                      validate: value => {
                        if (requiredForPayment) {
                          return (
                            value ||
                            errorMsg ||
                            'Please accept the terms to continue'
                          );
                        }
                        return true;
                      },
                    }}
                    render={({ field: { onChange, value } }) => (
                      <input
                        type="checkbox"
                        className="cursor-pointer rounded border-gray-300"
                        style={{ color }}
                        checked={value}
                        onChange={onChange}
                      />
                    )}
                  />
                ) : (
                  <Controller
                    control={control}
                    name={uniqueName}
                    defaultValue={defaultChecked}
                    rules={{
                      validate: value => {
                        if (requiredForPayment) {
                          return (
                            value ||
                            errorMsg ||
                            'Please accept the terms to continue'
                          );
                        }
                        return true;
                      },
                    }}
                    render={({ field: { onChange, value } }) => (
                      <ToggleButton
                        checked={value}
                        handleToggle={() => onChange(!value)}
                        style={{ color }}
                      />
                    )}
                  />
                )}
              </div>
              <div
                className="flex items-center justify-between w-full cursor-pointer"
                onClick={() => setIsOpen(!isopen)}>
                {showHeader && (
                  <div
                    className="checkbox-text ml-3 mt-1 text-left"
                    style={{ lineHeight: 1.5 }}
                    dangerouslySetInnerHTML={{ __html: headerContent }}
                  />
                )}
                {!showHeader && (
                  <div
                    className="checkbox-text ml-3 text-left"
                    style={{ lineHeight: 1.5 }}
                    dangerouslySetInnerHTML={{ __html: acknowledgeContent }}
                  />
                )}
                {showAcknowledgeDropdown && (
                  <div className={`ml-auto flex py-1`}>
                    <ArrowDown
                      onClick={() => setIsOpen(!isopen)}
                      fill="black"
                      className={`${isopen ? 'transform rotate-[180deg]' : ''} mx-2`}
                    />
                  </div>
                )}
              </div>
            </div>
            {showHeader && isopen && (
              <div
                className="checkbox-text ml-1 text-left"
                style={{ lineHeight: 1.5 }}
                dangerouslySetInnerHTML={{ __html: acknowledgeContent }}
              />
            )}
            {requiredForPayment && formState?.errors?.[uniqueName]?.message && (
              <div
                dangerouslySetInnerHTML={{
                  __html: errorMsg,
                }}
              />
            )}
          </div>
        </fieldset>
      </div>
    </React.Fragment>
  );
};
